import { Tabs } from '@acpaas-ui/react-components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route, Routes, useLocation, useMatch, useNavigate } from 'react-router-dom';
import { set } from '../../actions/breadcrumbs.actions';
import { ADMIN_BREADCRUMBS } from '../../constants/breadcrumbs.constants';
import { ADMIN_PATH, ADMIN_TAB_PATHS } from '../../constants/paths.constants';
import { authenticatedSelector, currentUserSelector, hasPermission } from '../../selectors/auth.selectors';
import AdminContacts from './tabs/contacts/AdminContacts';
import AdminOfferingDetails from './tabs/offerings/AdminOfferingDetails';
import AdminOfferingNew from './tabs/offerings/AdminOfferingNew';
import AdminOfferings from './tabs/offerings/AdminOfferings';
import AdminOrganizations from './tabs/organizations/AdminOrganizations';
import AdminTemplates from './tabs/templates/AdminTemplates';
import AdminThemes from './tabs/themes/AdminThemes';

const Admin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authenticated = useSelector(authenticatedSelector);
  const user = useSelector(currentUserSelector);
  const subpath = useMatch(`${ADMIN_PATH}/*`).params?.['*'] ?? null;
  const pathname = useLocation().pathname;

  const getIsTabActive = (tab) => {
    return pathname.includes(`${ADMIN_PATH}${tab.path}`);
  };

  const tabs = Object.values(ADMIN_TAB_PATHS)
    .filter((tab) => !tab.excludeFromNav)
    .filter((tab) => !tab.permission || hasPermission(user, tab.permission))
    .map((tab) => ({
      name: tab.name,
      target: tab.path,
      active: getIsTabActive(tab)
    }));

  useEffect(() => {
    if (subpath?.split('/')?.length === 1) {
      console.log('breadcrumbs set on top level');
      dispatch(set(ADMIN_BREADCRUMBS.LOADED({ tabs, pathname })));
    }
  }, [dispatch, subpath, tabs, pathname]);

  useEffect(() => {
    if (pathname === ADMIN_PATH) {
      navigate(`${ADMIN_PATH}${Object.values(ADMIN_TAB_PATHS)[0].path}`);
    }
  }, [navigate, pathname]);

  return (
    <div className="spo-p-admin u-margin-top u-margin-bottom-md">
      <div className="spo-p-admin__content">
        <h4 className="u-margin-bottom">Beheer</h4>
        <div className="spo-p-admin__content-nav">
          <Tabs
            align="left"
            items={tabs}
            linkProps={(props) => ({
              ...props,
              component: Link,
              to: `${ADMIN_PATH}${props.href === '/' ? '' : props.href}`
            })}
          />
        </div>
        <div className="spo-p-admin__content-tab u-padding">
          <Routes>
            <Route path={`${ADMIN_TAB_PATHS.ORGANIZATIONS.path}/*`} element={<AdminOrganizations />} />
            <Route path={ADMIN_TAB_PATHS.CONTACTS.path} element={<AdminContacts />} />
            <Route path={ADMIN_TAB_PATHS.TEMPLATES.path} element={<AdminTemplates />} />
            <Route path={ADMIN_TAB_PATHS.THEMES.path} element={<AdminThemes />} />
            <Route path={ADMIN_TAB_PATHS.OFFERING.path} element={<AdminOfferings />} />
            <Route path={ADMIN_TAB_PATHS.OFFERING_NEW.path} element={<AdminOfferingNew />} />
            <Route path={ADMIN_TAB_PATHS.OFFERING_DETAIL.path} element={<AdminOfferingDetails />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Admin;
